import { Component, OnInit } from '@angular/core';
import { Observable } from "rxjs";
import { Course } from 'lms-api';
import { CourseFilterService } from '../_services/course-filter.service';
import { UserCourseDataService } from 'lms-api';

@Component({
  selector: 'app-course-list',
  templateUrl: './course-list.component.html',
  styleUrls: ['./course-list.component.scss']
})
export class CourseListComponent implements OnInit {
  public courses$: Observable<Course[]>;
  public mbtCodes: string[];

  constructor(
    private courseFilterService: CourseFilterService, 
    private ucdService: UserCourseDataService) { 
      this.courses$ = this.ucdService.Courses$;
    }

  ngOnInit() {
    this.ucdService.User.subscribe(user => {
      this.mbtCodes = user.GetMemberTypes('abmp');
    })
  }
}